

export enum TileType {
  WATER = 'w',
  FORREST = 'f',
  VILLAGE = 'v',
  START = 's',
  MOUNTAIN = 'm',
  ENDWATER = 'ew',
  ENDFORREST = 'ef',
  BASECAMP = 'b',
  DISCARD = 'd'
}

export const valueTiles = [
  TileType.FORREST,
  TileType.WATER,
  TileType.VILLAGE,
  TileType.BASECAMP,
  TileType.DISCARD
];

export interface Tile {
  type: string,
  value: null
}

export function isValueTile(type: TileType) {
  return valueTiles.indexOf(type) !== -1;
}


// WEBPACK FOOTER //
// ./src/app/tile.ts